/**
 * @doc     https://github.com/mirari/v-viewer
 */
import Vue from 'vue';
import Viewer from 'v-viewer';

import 'viewerjs/dist/viewer.css';

Vue.use(Viewer);
